<template>
  <div class="row justify-content-center">
    <div class="col-md-5" >
      <form @submit.prevent="onFormSubmit">
        <h2 style="margin-bottom: 20px;">Login</h2>
        <div class="form-group">
          <input type="email" required class="form-control" placeholder="email" v-model="email" autofocus="">
        </div>
        <div class="form-group">
          <input @keypress.enter.prevent="onFormSubmit" type="password" required class="form-control" placeholder="password" v-model="password">
        </div>
        <p class="error">{{ error.message }}</p>
        <div class="form-group">
          <button class="btn btn-primary btn-block">ACCEDI</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { db, auth } from '../firebase/config.js'
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    data() {
      return {
        email: '',
        password: '',
        /*logged: false, */
        error: {
          value: null,
          message: ''
        }
      }
    },
    computed: {
      ...mapGetters({
          // map `this.user` to `this.$store.getters.user`
          user: "user"
       })
    },
    methods: {
      onFormSubmit(event) {
        event.preventDefault()
        // Sign-in
        auth.signInWithEmailAndPassword(this.email , this.password)
        .then(userCredential => {
          console.log(userCredential.user.displayName, userCredential.user.uid, "LOGIN OK!");
          if(!userCredential.user) {
            throw new Error('Invalid Credential');
          }
          // Get user token
          auth.currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Get customClaims if they are defined
            if (!idTokenResult.claims) {
              throw new Error('Claims undefined')
            }

            const claims = {
              isAdmin: idTokenResult.claims.isAdmin,
              orgId: idTokenResult.claims.orgId,
              role: idTokenResult.claims.role
            }
            console.log('claims', claims)
            this.set_user_claims(claims);
            console.log('user_claims', this.user.claims)

            // get store / company name
            let storeId = 'undefined!'
            let storeName = 'undefined!'
            let storeDefaults = {}

            const stores = []
            db.collection('stores')
            .where('orgId', '==', claims.orgId)
            .get()
            .then((snapShot) => {
              snapShot.forEach((doc) => {
                if(!doc.exists) throw new Error('No Stores for OrgId:', claims.orgId)
                console.log('store', doc.id, doc.data())
                stores.push({
                  id: doc.id,
                  ...doc.data()
                })
              })
              if(stores.length == 1) {
                storeId = stores[0].id
                storeName = stores[0].name + ' (' + stores[0].defaults.province + ')'
                storeDefaults = stores[0].defaults
              } else { 
                alert('ERROR: multiple stores for same orgId NOT still managed!')
                throw new Error('Multiple stores NOT managed for orgId', claims.orgId)
              }
              const user = {
                ...userCredential.user,
                storeId: storeId,
                storeName: storeName,
                storeDefaults: storeDefaults
              }
              this.user.loggedIn = true
              this.set_user(user);
              console.log('LoggedIn / User / claims: ', this.user.loggedIn, this.user.data, this.user.claims)
              this.error.message = '';
              //this.$store.commit("toggleLogged", true);
              //this.$router.push({ name: 'list_users' })
            })
            .catch((err) => {
              console.log(err);
              throw new Error(err.message + 'Organization not found')
            })
          })
          .catch((err) => {
            console.log(err);
            throw new Error(err.message + 'Token not found');
          })
        })
        .catch((err) => {
          console.log(err);
          this.error.message = err.message;
        })
      },
      ...mapMutations({
        set_user: 'SET_USER', // map `this.set_user()` to `this.$store.commit('SET_USER')`
        set_user_claims: 'SET_USER_CLAIMS', // map `this.set_user_claims()` to `this.$store.commit('SET_USER_CLAIMS')`
      })
    }
  };
</script>

<style>
  .form-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-right: 10px !important;
    align-items: center
  }
  label {
    width: 30%;
    color: #555;
  }
  input {
    width: 70%;
    color: #111;
    border: 0px;
    border-bottom: 1px;
    border-bottom-color: #555;
  }
  .btn-primary {
    margin: 20px;
    margin-bottom: 30px;
    border-radius: 20px;
    background: #bad300;
    border: #aac100;
    width: 40%;
    align-items: center
  }
  .btn-primary:hover {
    background: #777;
  }
  .btn-primary:a {
    background: #777;
  }
  .error {
    font-size: small;
    color: $#f81e47;
  }
</style>